import { render, staticRenderFns } from "./ReceiptList.vue?vue&type=template&id=24b96951&scoped=true"
import script from "./ReceiptList.vue?vue&type=script&lang=js"
export * from "./ReceiptList.vue?vue&type=script&lang=js"
import style0 from "./ReceiptList.vue?vue&type=style&index=0&id=24b96951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b96951",
  null
  
)

export default component.exports